var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-chip',{attrs:{"text-color":"white","label":"","small":"","color":_vm.color}},[_vm._v("\n    "+_vm._s(_vm.item.Title)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }